import { AdvertisementImgBoxBase } from '../../components/advertisementImgBox'
import { BoxCutBase } from '../../../components/boxCut'
import { FallbackBackgroundBase } from '../../../components/fallbackBackground'
import { FavoriteIconBase } from '../../../components/favoriteIcon'
import { GetCssVarManager } from '../../../../components/baseCssVarProvide'
import { LabelGameStatusBase } from '../../../components/labelGameStatus'
import { LogoHasBackgroundBase } from '../../components/advertisementImgBox/logoHasBackground'
import { MaskMaintainBase } from '../../../components/maskMaintain'
import { OuterBoxBase } from '../../components/outerBox'
import { TriangleHeartBase } from '../../../components/favoriteIcon/triangleHeart'

/** 标准正方型卡片的cssVarManager */
export abstract class _CssVarManagerBase {
  /** 最外层盒子 */
  abstract outerBox: GetCssVarManager<OuterBoxBase>
  /** 裁剪盒子 */
  abstract boxCut: GetCssVarManager<BoxCutBase>
  /** 广告盒子 */
  abstract advertisementImgBox: GetCssVarManager<AdvertisementImgBoxBase>
  /** 带有背景图的logo */
  abstract logoHasBackground: GetCssVarManager<LogoHasBackgroundBase>
  /** 兜底图片 */
  abstract fallbackBackground: GetCssVarManager<FallbackBackgroundBase>
  /** 标签名称 */
  abstract labelGameStatus: GetCssVarManager<LabelGameStatusBase>
  /** 维护图标 */
  abstract maskMaintain: GetCssVarManager<MaskMaintainBase>
  /** 收藏图标位置 */
  abstract favoriteIcon: GetCssVarManager<FavoriteIconBase>
  /** 三角+心型收藏图标尺寸 */
  abstract triangleHeart: GetCssVarManager<TriangleHeartBase>
}
